import React, { forwardRef, HTMLAttributes, ReactNode, Ref } from "react";

import classNames from "classnames";

import { StyledHeader } from "./Styles";

export interface IHeaderProps {
  /** CSS classes. */
  className?: string;
  /** Size */
  size?: "small" | "big";
  /** Children */
  children: ReactNode;
}

export const Header = forwardRef(
  (
    {
      className,
      size = "small",
      children,
      ...rest
    }: HTMLAttributes<HTMLDivElement> & IHeaderProps,
    ref: Ref<HTMLDivElement> | null | undefined
  ) => {
    return (
      <StyledHeader
        type="paper-2"
        className={classNames("c-header", className)}
        size={size}
        ref={ref}
        {...rest}
      >
        {children}
      </StyledHeader>
    );
  }
);

Header.displayName = "Header";
